import { render, staticRenderFns } from "./FootGuide.vue?vue&type=template&id=3b7cc93a&scoped=true&"
import script from "./FootGuide.vue?vue&type=script&lang=js&"
export * from "./FootGuide.vue?vue&type=script&lang=js&"
import style0 from "./FootGuide.vue?vue&type=style&index=0&id=3b7cc93a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7cc93a",
  null
  
)

export default component.exports